<div class="container">
  <ui-page-template [bgBlue]="true" [showFooter]="true">
    <div slot="content" class="content">
      <app-error-screen></app-error-screen>
    </div>
  </ui-page-template>
</div>
